import { ClassStudent } from '../context/types';

const formatStudentName = (student: ClassStudent) => {
    const lastName = student.last_name ? student.last_name.replace(' ', '_') : '';
    const firstName = student.first_name ? student.first_name.replace(' ', '_') : '';

    if (firstName !== '') {
        return lastName !== '' ? `${firstName}_${lastName}` : firstName;
    }

    return student.user_name ?? '';
};

export default formatStudentName;
